<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Ajuste"
          directory="Loc. Crítica o U. Técnica"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        modal-id="modal-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea regenerar el documento de alcance?"
      />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { TableHelpers } from "./TableHelpers";
import { axiosGet, axiosPost} from "@/app/helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      tableId: "setting-location-index",
      isEditModalActive: false,
      selectedUrl: "",
      rowData: {},
      accAppId: "",
      deleteConfirmationModalActive: false,
      options: {
        name: "setting-location-index",
        url: `/accreditationtechnical/setting-information/location/index`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("Regenerar Alcances"),
            icon: "file-text",
            type: "none",
          },
        ],
        filters: [
          {
            title: "Tipo",
            type: "drop-down-filter",
            key: "accreditation_type",
            option: [],
          },
          {
            title: "Actividad",
            type: "drop-down-filter",
            key: "accreditation_activity",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.searchAndSelectFilterOptions();
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `/accreditationtechnical/setting-information/location/view/${rowData.id}`;
        window.location = this.selectedUrl;
      } else if (actionObj.title == this.$t("Regenerar Alcances")) {
        this.selectedUrl = `accreditations/virtualSite/show/${rowData.id}`;
        this.openDeleteModal();
      }
    },

    data() {},

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `/accreditationtechnical/setting-information/location/generate-scope?accAppId=${this.rowData.id}`;
      this.deleteLoader = true;
      axiosPost(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("Registro regenerado satisfactoriamente"));
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    reSetData() {
      this.rowData = {};
      // this.selectedUrl = "";
    },

    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    searchAndSelectFilterOptions() {
      let url = `accreditations/applications/options`;
      axiosGet(url).then((response) => {
        const activityList = this.options.filters.find(element => element.title === 'Actividad')
        activityList.option = response.data.accreditationActivities;

        const typeList = this.options.filters.find(element => element.title === 'Tipo')
        typeList.option = response.data.accreditationTypesSetting;
      } );
    }
  },
};
</script>

<style>
</style>